export default function Loading({ show }) {
    return  <div id="app-loading" className={show ? 'visible' : ''}>
        <div className="linear-activity">
            <div className="indeterminate" />
        </div>
    </div>
}